import { RequestRef, RequestTimingInfo } from '@csp/csp-common-scheduling';
import { VisitRequest } from './VisitRequest';

export type GeneratedVisit = RequestTimingInfo & {
  requestRef: RequestRef;
  request: VisitRequest;
};

const from = (visitRequest: VisitRequest, isRepeating: boolean, requestRef: RequestRef): GeneratedVisit => ({
  repeating: isRepeating,
  timebound: isRepeating ? true : requestRef.windowEnd !== undefined,
  requestRef,
  request: visitRequest,
});

export const GeneratedVisit = { from };
